import axios from 'axios';
import { realtimeService } from '../services/realtimeService';

let redirectScheduled = false;

/**
 * True when the server rejected the session (expired JWT, missing token on protected route, inactive account).
 * Not for wrong login password or wrong "current password" on change-password.
 */
export function isAuthSessionInvalid(error) {
  const res = error.response;
  if (!res) return false;
  const { status, data } = res;
  const err = data?.error;
  const url = (error.config?.url || '').replace(/^https?:\/\/[^/]+/, '');

  if (status === 403 && err === 'Invalid token') return true;
  if (status === 403 && err === 'Account inactive') return true;

  if (status === 401) {
    if (url.includes('/api/auth/login')) return false;
    if (url.includes('/api/auth/change-password') && err === 'Invalid current password') return false;
    const authz = error.config?.headers?.Authorization || error.config?.headers?.authorization;
    if (authz && (err === 'Access token required' || err === 'Authentication required')) return true;
  }
  return false;
}

/**
 * Clear client session and go to login with an explanatory query string.
 * Preserves current path in ?redirect= for after sign-in when possible.
 * @param {'expired'|'inactive'} reason
 */
export function forceSessionRelogin(reason = 'expired') {
  if (typeof window === 'undefined') return;
  if (window.location.pathname === '/login') return;
  if (redirectScheduled) return;
  redirectScheduled = true;

  localStorage.removeItem('token');
  delete axios.defaults.headers.common['Authorization'];
  realtimeService.setToken(null);

  const path = `${window.location.pathname}${window.location.search}`;
  const params = new URLSearchParams();
  if (reason === 'inactive') {
    params.set('reason', 'inactive');
  } else {
    params.set('session', 'expired');
  }
  if (path && path !== '/' && !path.startsWith('/login')) {
    params.set('redirect', path);
  }
  window.location.replace(`/login?${params.toString()}`);
}

export function registerAxiosSessionInterceptor() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (isAuthSessionInvalid(error)) {
        const inactive = error.response?.data?.error === 'Account inactive';
        forceSessionRelogin(inactive ? 'inactive' : 'expired');
      }
      return Promise.reject(error);
    }
  );
}
